(function HotelEngineRoomModalContent($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['close-modal'],
		props: {
			rate: {
				type    : Object,
				required: true,
			}
		},
		template: `
			<div id="cancelation-policies">
				<b>Cancellation Policies</b>
				<ul
					v-for="(policy, index) in rate?.cancellation_policies"
				>
					<li v-html="policy.text"></li>
				</ul>
				<div
					v-for="(policy, index) in rate?.provider_data?.other_policies"
				>
					<span>{{ policy.title }} - </span>
					<ul v-if="Array.isArray(policy.text)">
						<li v-for="(textItem, textIndex) in policy.text" :key="textIndex" v-html="textItem"></li>
					</ul>
					<span v-else><p v-html="policy.text"></p></span>
				</div>
				<span><b>Note:</b> Cancellation policies are based on the local time of the hotel.</span>
			</div>
			<div id="room-more-details">
				<p v-if="rate?.description !== rate?.name" v-html="rate?.description"></p>
				<p v-if="rate?.provider_data?.board_name" v-html="rate?.provider_data?.board_name"></p>
				<p v-if="rate?.provider_data?.occupancy"><b>Occupancy:</b> <span
					v-html="rate?.provider_data?.occupancy"></span></p>
				<p v-if="rate?.provider_data?.tarrif_notes"><b>Tariff Notes:</b> <span
					v-html="rate?.provider_data?.tarrif_notes"></span></p>
				<p v-if="rate?.provider_data?.square_feet"><b>Sq. Feet:</b> <span
					v-html="rate?.provider_data?.square_feet"></span></p>
				<div v-if="rate?.provider_data?.rate_comments">
					<p
						v-for="(comment, index) in rate?.provider_data?.rate_comments"
					>
						<span v-html="comment.description"></span>
					</p>
				</div>
				<span>Hotel availability, pricing, cancellation policies, and rate details are subject to change during the booking process. Final details will be confirmed at checkout.</span>
			</div>
		`,
		data() {
			return {
				baseUri: Adzuki.base_uri,
			};
		},
		computed: {
		},
		methods: {
			closeModal() {
				this.$emit('close-modal');
			}
		},
		watch: {
		},
	};

	Adzuki.VueComponents.HotelEngineRoomModalContent = component;
}(jQuery, window.Adzuki || {}));
